import { render, staticRenderFns } from "./TheTermsAndConditions.vue?vue&type=template&id=29ba5bde&scoped=true&"
import script from "./TheTermsAndConditions.vue?vue&type=script&lang=js&"
export * from "./TheTermsAndConditions.vue?vue&type=script&lang=js&"
import style0 from "./TheTermsAndConditions.vue?vue&type=style&index=0&id=29ba5bde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ba5bde",
  null
  
)

component.options.__file = "TheTermsAndConditions.vue"
export default component.exports